import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Input from "../../../Components/Utils/Input";

import { Form, Formik } from "formik";
import * as Yup from "yup";
// import BasicInput from "../../../Components/Utils/BasicInput";
// import Input from "../../../Components/Utils/Input";
import { ThreeDots } from "react-loader-spinner";
import messageSlice from "../../Redux/MessageSlice";
import BaseApi from "../../Http/BaseApi";
import { getAcademicSessionsAsync } from "../../Redux/MasterSlice";
import PageTitle from "../../Components/Common/PageTitle";
import Alert from "../../Components/Utils/Alert";
import { useParams } from "react-router-dom";
import {
  getBudgetMastersAsync,
  getCostCentersAsync,
} from "../../Redux/BudgetSlice";
import Button from "../../Components/Utils/Button";
import tableToCSV from "../../Components/Utils/TableToCSV";
// import Input from "../../Components/Utils/Input";
// import Button from "../../Components/Utils/Button";
// import BasicInput from "../../../Components/Utils/BasicInput";

export default function BudgetProposalsHeadWise() {
  const { type } = useParams();
  const { acc_budget_form_id } = useParams();
  const { head_id } = useParams();

  const dispatch = useDispatch();
  const formikRef = useRef();
  const [initialValues, setInitialValues] = useState();
  const [loading, setLoading] = useState(false);

  const [proposals, setProposals] = useState([]);
  const master = useSelector((state) => state.master);
  const budget = useSelector((state) => state.budget);
  const costCenters = [...budget.costCenters];
  const [selectedHead, setSelectedHead] = useState([]);

  const academicSessions = [...master.academicSessions];
  const { message } = useSelector((state) => state.message);
  const budgetMasters = [...budget.budgetMasters];

  // const [formRole, setFormRole] = useState("add");

  //   const dispatch = useDispatch();
  useEffect(() => {
    dispatch(messageSlice.actions.clearMessage());
    // if (!can("View Attendance Sheet")) {
    //   navigate(`/not-found`);
    // }

    // dispatch(messageSlice.actions.clearMessage());
    if (academicSessions.length === 0) {
      dispatch(getAcademicSessionsAsync());
    }
    if (costCenters.length === 0) {
      dispatch(getCostCentersAsync());
    }
    if (budgetMasters.length === 0) {
      dispatch(getBudgetMastersAsync());
    }
    setInitialValues({
      acc_budget_form_id: acc_budget_form_id,
    });

    callProposals(acc_budget_form_id, head_id);
    callHeadDetails(head_id);
    // dispatch(getOldStudentsAsync());
  }, [dispatch]);
  console.log(initialValues);
  let budgetMaster = budgetMasters.find((e) => e.id == acc_budget_form_id);

  let currentSession = academicSessions.find((e) => {
    return e.id == budgetMaster?.academic_session_id;
  });

  let lastSession = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 1;
  });

  let last2Session = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 2;
  });

  const validationSchema = Yup.object().shape({
    acc_budget_form_id: Yup.string().required("This field is required!"),
  });

  // const handleSubmit = async (payload) => {
  //   dispatch(messageSlice.actions.clearMessage());
  //   console.log(payload);
  //   setLoading(true);
  //   await BaseApi().post(`budget-proposal-submit`, payload);

  //   setLoading(false);
  //   // resetForm({ academic_session_id: "", details: [] });

  //   // setInitialValues({
  //   //   academic_session_id: "",
  //   //   type: type,
  //   //   details: [],
  //   // });
  //   dispatch(messageSlice.actions.setMessage("Budget Submitted Successfully"));
  // };

  const callProposals = async (acc_budget_form_id, head_id) => {
    setLoading(true);
    const _proposals = await BaseApi().get(`budget-proposals`, {
      params: {
        acc_budget_form_id: acc_budget_form_id,
        head_id: head_id,
        cost_center_id: "all",
      },
    });

    setProposals(_proposals.data);

    setInitialValues({
      acc_budget_form_id: acc_budget_form_id,
    });
    setLoading(false);
  };

  const callHeadDetails = async (head_id) => {
    setLoading(true);
    const _selectedHead = await BaseApi().get(`acc-payment-heads/${head_id}`);
    setSelectedHead(_selectedHead.data);
    setLoading(false);
  };

  return (
    <>
      <div className="py-2">
        <div className="mx-auto container min-h-screen bg-white dark:bg-gray-800 shadow rounded">
          <div className="w-full px-5   ">
            <PageTitle
              name={
                "Budget " +
                (type == "receipt" ? "Receipt " : "Payment " + " Details ") +
                currentSession?.label
              }
            />
            {message && <Alert message={message} />}
            <Formik
              innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
            >
              <Form>
                <div className=" py-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 pt-6 gap-8"></div>
                {loading == true && (
                  <>
                    <div className="flex">
                      <span className="m-auto">
                        <ThreeDots
                          height="100"
                          width="100"
                          color="grey"
                          ariaLabel="loading"
                        />
                      </span>
                    </div>
                  </>
                )}
                {/* <h1 className="my-5 font-medium text-xl">
                  {selectedHead?.code} - {selectedHead?.name}
                </h1>{" "}
                <h1 className="my-5 font-medium text-md">
                  {" "}
                  {type == "receipt" ? "Receipt" : "Payment"} Side:
                </h1> */}
                <Button
                  type="button"
                  classNames="float-right bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                  value={"Download CSV"}
                  onClick={() => tableToCSV("datatable")}
                  icon={"DownloadIcon"}
                />
                <table
                  id="datatable"
                  className="min-w-full mt-5 bg-white dark:bg-gray-800"
                >
                  <thead>
                    <tr>
                      <th className="text-left" colSpan={5}>
                        <h1 className="my-5 font-medium text-xl">
                          {selectedHead?.code} - {selectedHead?.name}
                        </h1>{" "}
                        <h1 className="my-5 font-medium text-md">
                          {" "}
                          {type == "receipt" ? "Receipt" : "Payment"} Side:
                        </h1>
                      </th>
                    </tr>
                    <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                      <th className="table-head">Particulars</th>
                      <th className="table-head">
                        {" "}
                        Actual
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 2;
                          })?.label
                        }
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }
                      </th>
                      <th className="table-head">
                        {" "}
                        Revised
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget {currentSession?.label}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {costCenters.map((costCenter) => {
                      return (
                        <>
                          <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                            <td className="table-data"> {costCenter.name}</td>
                            <td className="table-data">
                              {" "}
                              {proposals
                                ?.filter(
                                  (p) =>
                                    p.acc_payment_head_id == head_id &&
                                    p.academic_session_id == last2Session.id &&
                                    p.budget_type == 2 &&
                                    p.acc_cost_center_id == costCenter.id
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal[
                                        type == "receipt"
                                          ? "proposed_amount_receipt"
                                          : "proposed_amount_payment"
                                      ]
                                    ) || 0),
                                  0
                                )
                                .toFixed(2)}
                            </td>
                            <td className="table-data">
                              {" "}
                              {proposals
                                ?.filter(
                                  (p) =>
                                    p.acc_payment_head_id == head_id &&
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 0 &&
                                    p.acc_cost_center_id == costCenter.id
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal[
                                        type == "receipt"
                                          ? "proposed_amount_receipt"
                                          : "proposed_amount_payment"
                                      ]
                                    ) || 0),
                                  0
                                )
                                .toFixed(2)}
                            </td>
                            <td className="table-data">
                              {" "}
                              {proposals
                                ?.filter(
                                  (p) =>
                                    p.acc_payment_head_id == head_id &&
                                    p.academic_session_id == lastSession.id &&
                                    p.budget_type == 1 &&
                                    p.acc_cost_center_id == costCenter.id
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal[
                                        type == "receipt"
                                          ? "proposed_amount_receipt"
                                          : "proposed_amount_payment"
                                      ]
                                    ) || 0),
                                  0
                                )
                                .toFixed(2)}
                            </td>
                            <td className="table-data">
                              {" "}
                              {proposals
                                ?.filter(
                                  (p) =>
                                    p.acc_payment_head_id == head_id &&
                                    p.academic_session_id ==
                                      currentSession.id &&
                                    p.budget_type == 0 &&
                                    p.acc_cost_center_id == costCenter.id
                                )
                                ?.reduce(
                                  (partialSum, proposal) =>
                                    partialSum +
                                    (parseInt(
                                      proposal[
                                        type == "receipt"
                                          ? "proposed_amount_receipt"
                                          : "proposed_amount_payment"
                                      ]
                                    ) || 0),
                                  0
                                )
                                .toFixed(2)}{" "}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                      <th className="table-head">Total</th>
                      <th className="table-head">
                        {" "}
                        {proposals
                          .filter(
                            (p) =>
                              p.academic_session_id == last2Session.id &&
                              p.budget_type == 2
                          )
                          ?.reduce(
                            (partialSum, proposal) =>
                              partialSum +
                              (parseInt(
                                proposal[
                                  type == "receipt"
                                    ? "proposed_amount_receipt"
                                    : "proposed_amount_payment"
                                ]
                              ) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {" "}
                        {proposals
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, proposal) =>
                              partialSum +
                              (parseInt(
                                proposal[
                                  type == "receipt"
                                    ? "proposed_amount_receipt"
                                    : "proposed_amount_payment"
                                ]
                              ) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {" "}
                        {proposals
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 1
                          )
                          ?.reduce(
                            (partialSum, proposal) =>
                              partialSum +
                              (parseInt(
                                proposal[
                                  type == "receipt"
                                    ? "proposed_amount_receipt"
                                    : "proposed_amount_payment"
                                ]
                              ) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {proposals
                          .filter(
                            (p) =>
                              p.academic_session_id == currentSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, proposal) =>
                              partialSum +
                              (parseInt(
                                proposal[
                                  type == "receipt"
                                    ? "proposed_amount_receipt"
                                    : "proposed_amount_payment"
                                ]
                              ) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                    </tr>
                  </tfoot>
                </table>
                <hr className="m-10" />
              </Form>
            </Formik>

            <br />
          </div>
        </div>
      </div>
    </>
  );
}
